import { CalendarMonthOutlined, GroupsOutlined } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FgaUserState, type DetailedUserDto } from '@/generated/model';
import { formatMediumDate } from '@/shared/utils/dateFormatting';

import { RoleChip } from '../role-chip/RoleChip';
import { UserDetailsSection } from './UserDetailsSection';

type UserDetailsPermissionsProps = {
  user: DetailedUserDto;
  language: string;
};

export function UserDetailsPermissions({ user, language }: UserDetailsPermissionsProps) {
  const { t } = useTranslation();
  const role = user.role.role;

  return (
    <Box>
      <Typography variant="overline" component="h3" color="text.secondary" px={1.5}>
        {t('userAccessControl.details.permissions')}
      </Typography>
      <Stack spacing={1}>
        {user.registeredAt && (
          <UserDetailsSection icon={<CalendarMonthOutlined />}>
            <Typography variant="subtitle2">{t('userAccessControl.fields.registeredAt')}</Typography>
            <Typography variant="body1">{formatMediumDate(user.registeredAt, language)}</Typography>
          </UserDetailsSection>
        )}

        <UserDetailsSection icon={<GroupsOutlined />}>
          <Typography variant="subtitle2">{t('userAccessControl.details.roles')}</Typography>
          {role ? (
            <RoleChip role={role} isUserDeactivated={user.state === FgaUserState.DEACTIVATED} />
          ) : (
            <Typography variant="body1">{t('userAccessControl.details.notAvailable')}</Typography>
          )}
          <Typography variant="body2" color="text.secondary" mt={0.5}>
            {t('userAccessControl.details.roleDescription')}
          </Typography>
        </UserDetailsSection>
      </Stack>
    </Box>
  );
}
